<template>
  <f7-page no-toolbar no-swipeback>

    <!-- Top Navbar -->
    <f7-navbar :sliding="false" theme-dark>
      <f7-nav-right>
        <img src="static/logo_frekr.png" style="height: 1.8em;" />
        <f7-link icon-material="sync" href="/" style="visibility: hidden; width: 0px;" />
      </f7-nav-right>
    </f7-navbar>

    <f7-block class="onboarding-copy">
      <h1>{{ trans('help:title') }}</h1>
      <p>{{ trans('info:personal') }}</p>
      <span v-html="bb(trans('info:install'))"></span><br />
    </f7-block>
    <f7-block class="onboarding-copy">
      <span v-html="bb(trans('info:install:'+platform+':'+browser, 'info:install:unavailable'))"></span>
      <f7-button href="/" :text="trans('nav:refresh')" icon-material="sync" />
    </f7-block>
    <f7-block class="onboarding-copy"><p>{{ trans('info:code_source') }}</p><a :href="trans('help:url')" target="_blank" rel="noopener" class="external">{{ trans('help:more') }}</a></f7-block>
  </f7-page>
</template>

<script>
  import Preferences from '../js/preferences.js';

  export default {
    data() {
      return {
        platform: Preferences.getPlatform(),
        browser: Preferences.getBrowser()
      }
    },
  }
</script>
